import "components/v2/FormField/formFields.css";
import FileField from "components/FileField";
import { MAX_BOOK_COVER_MB, MAX_BOOK_PDF_MB } from "utils";

export default function BookFilesFields({ values, errors = {}, touched = {}, setFieldValue, setFieldTouched,
	hasExistingCover = false, hasExistingFile = false, onShowCoverField, onShowFileField, disabled = false }) {
	const select = (name, callback) => (file) => {
		setFieldValue(name, file);
		setFieldTouched?.(name, true, false);
		callback?.();
	};
	return <div className="space-y-4">
		<p className="text-sm text-gray-500">Choose the files for this book. Your book details stay the same when you replace a file.</p>
		<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
			{[
				{ name: "book_cover", label: "Book cover", accept: "image/jpeg,image/png,image/svg+xml,image/webp", hint: `JPG, PNG, SVG or WebP · Up to ${MAX_BOOK_COVER_MB} MB`, max: MAX_BOOK_COVER_MB, existing: hasExistingCover, callback: onShowCoverField },
				{ name: "book_file", label: "Digital book", accept: "application/pdf,.pdf", hint: `PDF document · Up to ${MAX_BOOK_PDF_MB} MB`, max: MAX_BOOK_PDF_MB, existing: hasExistingFile, callback: onShowFileField },
			].map(({ name, label, accept, hint, max, existing, callback }) => <div className="akello-field" key={name}>
				<label htmlFor={name} className="akello-field-label">{label}</label>
				<FileField id={name} name={name} label={label} file={values?.[name]} accept={accept} hint={hint} maxSize={max * 1024 * 1024}
					existing={existing} disabled={disabled} invalid={!!(touched[name] && errors[name])} describedBy={touched[name] && errors[name] ? `${name}-error` : undefined} onSelect={select(name, callback)} />
				{touched[name] && errors[name] && <p id={`${name}-error`} role="alert" className="akello-field-error">{errors[name]}</p>}
			</div>)}
		</div>
	</div>;
}
